import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import { useAuth, API } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [state, setState] = useState("Verifying your email…");
  const token = params.get("token");

  useEffect(() => {
    if (!token) {
      setState("This verification link is incomplete.");
      return;
    }
    axios.post(`${API}/auth/email/verify`, { token })
      .then(({ data }) => {
        setUser(data);
        setState("Your email is verified. Redirecting to your workspace…");
        window.setTimeout(() => nav("/dashboard"), 900);
      })
      .catch((error) => setState(error.response?.data?.detail || "We could not verify this link."));
  }, [nav, setUser, token]);

  return <AccessMessage title="Verify your email" message={state} />;
}

export function AccessMessage({ title, message }) {
  return <div className="min-h-screen bg-bone"><Navbar /><main className="max-w-xl mx-auto px-6 py-28 text-center">
    <div className="editorial-card p-10"><div className="overline mb-4">§ ACCOUNT SECURITY</div><h1 className="font-serif text-5xl">{title}</h1><p className="mt-6 text-[--muted-foreground]">{message}</p><Link className="btn-outline mt-8" to="/login">Go to sign in</Link></div>
  </main></div>;
}
